<template>
  <div>
    <van-popup v-model="show" position="right" style="height: 100%; width: 80%">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
        <div class="select_list">
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="发票状态" name="2">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="invoiceStatusIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in invoiceStatusOptions" :key="item.dictValue" @click="handleClick(item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field v-model="queryParams.custId" label="客户ID" placeholder="请输入客户ID" />
          <van-field v-model="queryParams.custName" label="客户名称" placeholder="请输入客户名称" />
          <van-field v-model="queryParams.contractNum" label="合同编号" placeholder="请输入合同编号" />
          <van-field v-model="queryParams.contractName" label="合同名称" placeholder="请输入合同名称" />
          <van-field v-model="queryParams.contractMoney" label="合同金额" type="number" placeholder="请输入合同金额" />
          <van-field v-model="queryParams.phaseNum" label="回款期数" placeholder="请输入回款期数" />
          <van-field v-model="queryParams.currPaymentMoney" label="回款金额" type="number" placeholder="请输入本次回款金额" />
          <van-field readonly clickable name="calendar" :value="value" label="回款期间" placeholder="点击选择日期范围" @click="showCalendar = true" />
          <van-field readonly clickable name="calendar" :value="InvoiceValue" label="开票时间" placeholder="点击选择日期" @click="showInvoice = true" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
      <!-- 回款期间 -->
      <van-calendar v-model="showCalendar" type="range" @confirm="onConfirm" :min-date="minDate" />
      <!-- 开票时间 -->
      <van-calendar v-model="showInvoice" @confirm="onInvoiceConfirm" :min-date="minDate" />
    </van-popup>
  </div>
</template>
<script>
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse, Calendar } from 'vant';
export default {
  name: 'SearchPop',
  props: {
    show: Boolean
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Calendar.name]: Calendar,
  },
  data() {
    return {
      value: null,
      InvoiceValue: null,
      showCalendar: false,
      showInvoice: false,
      activeNames: ['1'],
      showPop: this.show,
      invoiceTypeIndex: null,
      invoiceStatusIndex: null,
      queryParams: {},
      invoiceStatusOptions: [],
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
    }
  },
  mounted() {
    //发票状态
    this.getDicts("accinvoice_invoice_status").then(response => {
      this.invoiceStatusOptions = response.data; // string
    });
  },
  methods: {
    handleClick(type, prop, index) {
      this.queryParams.invoiceStatus = prop
      this.invoiceStatusIndex = index
    },
    resetQuery() {
      this.queryParams = {
        invoiceType: null,
        invoiceStatus: null,
        custId: null,
        custName: null,
        contractName: null,
        invoiceNum: null,
        taxNum: null,
        mobile: null
      }
      this.invoiceTypeIndex = null;
      this.invoiceStatusIndex = null;
    },
    submitForm() {
      this.$emit('handlequery', this.queryParams)
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.showCalendar = false;
      this.value = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      let params = {
        beginTime: this.formatDate(start),
        endTime: this.formatDate(end)
      }
      this.queryParams.params = params
    },
    onInvoiceConfirm(date) {
      this.showInvoice = false;
      this.InvoiceValue = this.formatDate(date);
      this.queryParams.openInvoiceTime = this.formatDate(date);
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
  },
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;

  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>